//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

import VipInfo from "./components/VipInfo";
import UserInfo from "./components/Userinfo";
import Balance from "./components/Balance";
import Ads from "./components/Ads";
import GridMenus from "./components/GridMenus";
import ListMenus from "./components/ListMenus";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      assetsInfoMap: (state) => state.userInfo.assetsInfoMap,
      accountBalance: (state) =>
        (state.userInfo.assetsInfoMap.accountBalance || 0).toFixed(2),
      userName: (state) => state.userInfo.userInfo.userAccount,
      isLogin: (state) => state.isLogin,
      UUID: (state) => state.UUID,
      Download_url: (state) => state.Download_url,
      FrontConfigList: (state) => state.FrontConfigList,
      vipInfo: (state) => state.userInfo.vipInfo,
    }),
  },
  components: {
    UserInfo,
    VipInfo,
    Balance,
    Ads,
    GridMenus,
    ListMenus,
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Base/index.vue